import React, { useEffect, useState } from 'react';
import toast, { Toaster } from 'react-hot-toast';
import DataTable from 'react-data-table-component';
import Select from 'react-select';
import { Link, useNavigate } from 'react-router-dom';
import {
    getPriceDetails,
    getPriceList,
    logItemPriceListHistory,
    activeDeactivePrice,
    getRecordsBySearch,
    loggedInUserUrls,
    getWarehouseKeyValueList,
    getAllRecordsByWarehouseId,
    getItemThatNotExistByWarehouseId1,
    addItemByWarehouseId1,
    removeItemByWarehouseId1,
    getOrgKeyValue,
    downloadItemPriceExcel,
    uploadItemPriceExcel
} from '../../../services/index';
import { BASE_URL_INVENTORY, DOWNLOAD_ITEM_PRICE_URL } from "../../../CONSTANTS";
import ImportExportIcon from "@mui/icons-material/ImportExport";
import DownloadIcon from "@mui/icons-material/Download";
import { Spinner } from "react-bootstrap";

import AddIcon from '@mui/icons-material/Add';
import SearchRoundedIcon from '@mui/icons-material/SearchRounded';
import EditIcon from '@mui/icons-material/Edit';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import Modal from 'react-bootstrap/Modal';
import HistoryIcon from '@mui/icons-material/History';
import Loader from '../../Common/Loader';
import Button from "@mui/material/Button";
import SyncIcon from "@mui/icons-material/Sync";

import PriceSyncModal from './PriceSyncModal';


const filterOptions = [
    { value: 'all', label: 'All' },
    { value: 'sales', label: 'Sales' },
    { value: 'purchase', label: 'Purchase' },
    { value: 'both', label: "Both" }
];

const PriceList = () => {
    let navigate = useNavigate();
    const orgDetail = JSON.parse(localStorage.getItem('orgDetail'));
    const [filteredData, setFilteredData] = useState([]);
    const [search, setSearch] = useState('');
    const [rows, setRows] = useState([]);
    const [logData, setLogData] = useState({});
    const [priceDetails1, setPriceDetails1] = useState([]);

    const [userRights, setUserRights] = useState("");
    const [showSyncModal, setShowSyncModal] = useState(false);
    const toggleSyncModal = () => setShowSyncModal(prev => !prev);

    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);


    const [show2, setShow2] = useState(false);
    const [loading, setLoading] = useState(false);
    const handleClose2 = () => setShow2(false);

    const [itemPriceType, setItemPriceType] = useState(filterOptions[0]);
    const [itemSearchQuery, setItemSearchQuery] = useState("");

    const [org, setOrg] = useState({});
    const [orgOptions, setOrgOptions] = useState([])

    const [showExcelModal, setShowExcelModal] = useState(false);
    const [selectedPriceList, setSelectedPriceList] = useState(null);
    const [fileForExcel, setFileForExcel] = useState({
        fileBase64: "",
        fileName: "",
    });
    const [excelUploading, setExcelUploading] = useState(false);

    const handleExcelClose = () => {
        setShowExcelModal(false);
        setSelectedPriceList(null);
        setFileForExcel({ fileBase64: "", fileName: "" });
    };

    const handleExcelShow = () => setShowExcelModal(true);

    const handleFileRead = async (event) => {
        const file = event.target.files[0];
        const base64 = await convertBase64(file);
        setFileForExcel({
            fileBase64: base64,
            fileName: file.name,
        });
    };


    const convertBase64 = (file) => {
        return new Promise((resolve, reject) => {
            const fileReader = new FileReader();
            fileReader.readAsDataURL(file);
            fileReader.onload = () => {
                resolve(fileReader.result);
            };
            fileReader.onerror = (error) => {
                reject(error);
            };
        });
    };

    const handleExcelUpload = () => {
        if (!selectedPriceList) {
            toast.error("Please select a price list");
            return;
        }
        if (!fileForExcel.fileBase64) {
            toast.error("Please select a file");
            return;
        }
        setExcelUploading(true);
        uploadItemPriceExcel(selectedPriceList.value, fileForExcel).then((res) => {
            if (res.errorCode === 0) {
                toast.success("File Uploaded Successfully");
                handleExcelClose();
            } else {
                toast.error(res.message || "Error In Uploading");
            }
            setExcelUploading(false);
        }).catch((error) => {
            toast.error("Server Error");
            setExcelUploading(false);
        });
    };


    useEffect(() => {
        loggedInUserUrls().then((res) => {
            if (res.errorCode === 0) {
                setUserRights(res.responsePacket);
            } else {
                toast.error(res.message);
            }
        });
        getOrgKeyValue().then((res) => {
            if (res.errorCode === 0) {
                const options = res.responsePacket?.map((d) => ({
                    value: d.key,
                    label: d.value,
                }));
                setOrg(options[0]);
                setOrgOptions(options);
            } else {
                toast(res.message);
            }
        });
    }, []);

    useEffect(() => {
        if (org.value) {
            getPriceRecords();
        }
    }, [org]);

    const getPriceRecords = () => {
        setLoading(true)
        var request = {
            page: 0,
            search: '',
            size: -1,
            uuid: org.value
        };
        getPriceList(request).then((res) => {
            if (res.errorCode === 0) {
                let d = res.responsePacket.data;
                d.reverse();
                setRows(d);
                setFilteredData(d);
                setLoading(false)
            } else {
                setLoading(false)
                toast(res.message);
            }
        }).catch(error => {
            console.error(error);
            setLoading(false);
        });
    };

    const columns = [
        {
            name: 'NAME',
            selector: (row) => row.title,
            width: "300px"
        },
        {
            name: 'PRICING TYPE',
            selector: (row) => row.itemPriceListTypeEnum,
            width: "160px"
        },
        {
            name: 'PRICING SCHEME',
            selector: (row) => (row.isUnitPrice ? 'Unit Pricing' : row.isVolumePrice ? 'Volume Pricing' : '-'),
            width: "160px"
        },
        {
            name: 'DETAILS',
            selector: (row) => (row.isIndividual ? 'Per Item Rate' : row.isMarkDown ? row.percentage + '% Markdown' : row.isMarkUp ? row.percentage + '% Markdown' : <></>),
            width: "160px"
        },
        {
            name: 'ORGANISATION TITLE',
            selector: (row) => row.organisationTitle,
            width: "300px"
        },

        {
            name: 'ACTION',
            selector: (row) => (

                <div>
                    {org.value === "59741534-b41f-4cfc-82a0-d44a176d7229" && (<EditIcon
                        style={{ fontSize: '15px', cursor: 'pointer' }}
                        onClick={() => {
                            navigate('/pricelists/' + row.recordId + '/edit');
                        }}
                    />)}
                    &nbsp;&nbsp;
                    {row.active ? (
                        <CheckCircleIcon
                            style={{
                                fontSize: '15px',
                                cursor: 'pointer',
                                color: 'greenyellow',
                            }}
                            onClick={() => handleActiveInactive(row)}
                        />
                    ) : (
                        <CancelIcon style={{ fontSize: '15px', cursor: 'pointer', color: 'tomato' }} onClick={() => handleActiveInactive(row)} />
                    )}
                    &nbsp;
                </div>
            ),
        },
    ];

    const handleSearch = (search) => {
        const result = rows.filter((data) => {
            const searchString = search.toLowerCase()
            const itemTitle = data.title.toLowerCase()
            let priceType = data.itemPriceListTypeEnum.toLowerCase()
            let query = itemTitle.includes(searchString) || priceType.includes(searchString)

            if (itemPriceType && itemPriceType.value && itemPriceType.value != "all" && (!searchString || searchString === "")) {
                query = priceType.includes(itemPriceType.value)
            }

            // If any price type is selected
            if (itemPriceType && itemPriceType.value && itemPriceType.value != "all" && searchString) {
                query = itemTitle.includes(searchString) && priceType.includes(itemPriceType.value)
            }

            return query;
        });
        setFilteredData(result);
    };

    const handleActiveInactive = (row) => {
        activeDeactivePrice(row.recordId).then((res) => {
            if (res.errorCode === 0) {
                getPriceRecords();
                toast(res.message);
            } else {
                toast(res.message);
                return;
            }
        });
    };

    const handleFilter = (e) => {
        if (e.value === 'isVolumePrice') {
            const arr1 = rows.filter((data) => data.isVolumePrice);
            setFilteredData(arr1);
        }
        if (e.value === 'isUnitPrice') {
            const arr2 = rows.filter((data) => data.isUnitPrice);
            setFilteredData(arr2);
        }
        if (e.value === 'isMarkUp') {
            const arr3 = rows.filter((data) => data.isMarkUp);
            setFilteredData(arr3);
        }
        if (e.value === 'isMarkDown') {
            const arr4 = rows.filter((data) => data.isMarkDown);
            setFilteredData(arr4);
        }

        if (e.value === 'sales' || e.value === 'purchase') {
            const arr4 = rows.filter((data) => data.itemPriceListTypeEnum.toLowerCase() === e.value);
            setFilteredData(arr4);
        }
        if (e.value === 'all') {
            const arr4 = rows.filter((data) => true);
            setFilteredData(arr4);
        }
        if (e.value === 'both') {
            let data1 = rows.filter((data) => data.itemPriceListTypeEnum.toLowerCase() === e.value);
            setFilteredData(data1);
        }

        setItemPriceType(e)
    };

    const handleItemListSearch = async (search = "") => {
        try {
            const rObj = {
                "page": 0,
                "search": search,
                "size": -1
            }
            setLoading(true)
            const res = await getRecordsBySearch(rObj)
            if (res) {
                if (res.errorCode === 0) {
                    let d = res.responsePacket.data;
                    d.reverse();
                    setRows(d);
                    setFilteredData(d);
                    setLoading(false)
                } else {
                    setLoading(false)
                    toast(res.message);
                }
            }
        } catch (error) {
            setLoading(false)
        }

    }

    const handleOrgSelect = (e) => {
        setOrg(e);
    }

    const assignSyncButton = () => {
        let buttonFlag = false;
        if (userRights.adminRoleEnum === "ROLE_SUPER_ADMIN") {
            buttonFlag = true;
        } else {
            userRights?.urlList?.map((url) => {
                if (url.url === 'itemPriceList/syncPrices') {
                    buttonFlag = true;
                }
            })
        }
        return buttonFlag;
    }

    return (
        <>
            <div style={{ height: 500, width: '100%' }}>

                <DataTable
                    className='customDataTable'
                    title='All Price Lists'
                    columns={columns}
                    data={filteredData}
                    pagination
                    fixedHeader
                    pointerOnHover={true}
                    highlightOnHover={true}
                    onRowClicked={(data) => navigate(`/pricelists/${data.recordId}`)}
                    subHeader
                    subHeaderComponent={
                        <div className='d-flex align-items-center gap-2'>
                            {orgDetail?.isDefault && <div style={{ zIndex: "3" }}>
                                <Select className='text-left' optiohandleItemListSearchSearchRoundedIcon options={orgOptions} value={org} onChange={handleOrgSelect} />
                            </div>}
                            <div className='d-flex align-items-center ml-2'>
                                <div className="d-flex align-items-center mr-2">
                                    <div className='input-group paginationSearchInput mr-0 pr-0' style={{ minWidth: "300px" }}>
                                        <div className='input-group-prepend '>
                                            <span className='input-group-text ' id='basic-addon1'>
                                                <SearchRoundedIcon />
                                            </span>

                                        </div>
                                        <input autoComplete='off' value={itemSearchQuery} className='form-control' type='search' placeholder='Search item list' onChange={(e) => {
                                            setItemSearchQuery(e.target.value)
                                            if (!e.target.value) {
                                                handleItemListSearch()
                                            }
                                        }} />
                                        <Button variant="contained" onClick={() => handleItemListSearch(itemSearchQuery)}>Search</Button>
                                    </div>
                                </div>
                                <div className='input-group paginationSearchInput mr-2' style={{ maxWidth: '180px' }}>

                                    <div className='input-group-prepend'>
                                        <span className='input-group-text' id='basic-addon1'>
                                            <SearchRoundedIcon />
                                        </span>
                                    </div>
                                    <input autoComplete='off' className='form-control' type='text' placeholder='Search price list' onChange={(e) => handleSearch(e.target.value)} />
                                </div>
                                <div style={{ width: '200px', zIndex: "3" }}>

                                    <Select className='text-left' value={itemPriceType} placeholder='Filter Items' options={filterOptions} onChange={handleFilter} />
                                </div>
                                <Link to='/pricelist/new' className='ember-view btn btn-primary d-flex align-items-center py-2 ml-2'>
                                    <AddIcon />
                                    New
                                </Link>
                                <div className="d-flex align-items-center">
                                    {(userRights?.adminRoleEnum === "ROLE_SUPER_ADMIN") && (
                                        <button className="ember-view btn btn-primary d-flex align-items-center py-2 ml-2" onClick={handleExcelShow}>
                                            <ImportExportIcon /> Excel
                                        </button>
                                    )}
                                    {assignSyncButton() && <button className='ember-view btn btn-primary d-flex align-items-center py-2 ml-2' onClick={toggleSyncModal}>
                                        <SyncIcon /> Sync
                                    </button>}
                                </div>

                            </div>
                        </div>
                    }
                    progressPending={loading}
                    progressComponent={<Loader />}
                />
            </div>

            {show2 && <Modal show={show2} onHide={handleClose2}>
                <Modal.Header>Log Info</Modal.Header>
                <Modal.Body>
                    <table>
                        {logData.length === 0 ? (
                            'No Changes Found'
                        ) : (
                            <tr>
                                <td>Date</td>
                                <td>Changes</td>
                            </tr>
                        )}
                        {logData.length >= 1 &&
                            logData?.map((history) => {
                                return (
                                    <>
                                        <tr>
                                            <td style={{ verticalAlign: 'top', width: '80px' }}>
                                                {history?.transactionDate?.substring(0, 10)}
                                                :&nbsp;&nbsp;
                                                <br />
                                                Time:
                                                {history?.transactionDate?.split('T')[1]?.substring(0, 5)}
                                            </td>

                                            <td>
                                                {history?.message.split('\n').map((b, i) => (
                                                    <tr>{b.includes('\t') ? <div style={{ marginLeft: '20px' }}>{b}</div> : b.includes('\t\t') ? <div style={{ marginLeft: '40px' }}>{b}</div> : b}</tr>
                                                ))}
                                            </td>
                                        </tr>
                                        <hr />
                                    </>
                                );
                            })}
                    </table>
                </Modal.Body>
            </Modal>}
            {show && <Modal show={show} onHide={handleClose} size={priceDetails1?.isMarkUp || priceDetails1?.isMarkDown ? '' : 'lg'}>
                <Modal.Header style={{ fontSize: '20px' }}>PriceList Info</Modal.Header>
                <Modal.Body>
                    <div>
                        <table className='customTable'>
                            <tr>
                                <td className='font-large text-uppercase font-xs text-open'>
                                    {priceDetails1?.isMarkUp ? 'markup' : <></>}
                                    {priceDetails1?.isMarkDown ? 'MarkDown' : <></>}
                                    {priceDetails1?.isUnitPrice ? 'UnitPrice' : <></>}
                                    {priceDetails1?.isVolumePrice ? 'VolumePrice' : <></>}
                                </td>
                            </tr>
                            <tr>
                                <td>Title:</td>
                                <td>{priceDetails1.title}</td>
                            </tr>

                            {priceDetails1?.isMarkDown || priceDetails1?.isMarkUp ? (
                                <tr>
                                    <td>Percentage:</td>
                                    <td>{priceDetails1.percentage}</td>
                                </tr>
                            ) : (
                                <></>
                            )}
                            <tr>
                                <td>Type:</td>
                                <td>{priceDetails1.itemPriceListTypeEnum}</td>
                            </tr>

                            <tr>
                                <td>Description:</td>
                                <td>{priceDetails1.description}</td>
                            </tr>
                        </table>

                        <br />

                        {priceDetails1?.isUnitPrice ? (
                            <>
                                {priceDetails1 && priceDetails1?.itemCustomUnitPriceBeanList.length !== 0 && (
                                    <table className='customTable'>
                                        <thead>
                                            <tr style={{ fontSize: '15px' }}> ITEM DETAILS</tr>
                                            <tr>
                                                <td>Item Title</td>
                                                <td>Unit</td>
                                                <td> Price</td>
                                                <td>Custom Price</td>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {priceDetails1 &&
                                                priceDetails1?.itemCustomUnitPriceBeanList.map((item, i) => (
                                                    <tr key={i}>
                                                        <td>{item.itemTitle}</td>
                                                        <td>{item.unitTitle}</td>
                                                        <td>{item.price}</td>
                                                        <td>{item.customPrice}</td>
                                                    </tr>
                                                ))}
                                        </tbody>
                                    </table>
                                )}
                            </>
                        ) : (
                            <></>
                        )}
                        {priceDetails1?.isVolumePrice ? (
                            <>
                                {' '}
                                {priceDetails1 && priceDetails1?.itemCustomVolumePriceBeansList.length !== 0 && (
                                    <table className='customTable'>
                                        <thead>
                                            {' '}
                                            <tr style={{ fontSize: '15px' }}> ITEM DETAILS</tr>
                                            <tr>
                                                <td>Item Title</td>
                                                <td>Unit</td>
                                                <td> Price</td>
                                                <td>Custom Price</td>
                                                <td>Start Quantity</td>
                                                <td>End Quantity</td>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {priceDetails1 &&
                                                priceDetails1?.itemCustomVolumePriceBeansList.map((item, i) => (
                                                    <tr key={i}>
                                                        <td>{item.itemTitle}</td>
                                                        <td>{item.unitTitle}</td>
                                                        <td>{item.price}</td>
                                                        <td>{item.customPrice}</td>
                                                        <td>{item.startQuantity}</td>
                                                        <td>{item.endQuantity}</td>
                                                    </tr>
                                                ))}
                                        </tbody>
                                    </table>
                                )}
                            </>
                        ) : (
                            <></>
                        )}
                    </div>
                </Modal.Body>
            </Modal>}

            {
                showSyncModal && <PriceSyncModal showSyncModal={showSyncModal} toggleSyncModal={toggleSyncModal} />
            }

            <Modal show={showExcelModal} onHide={handleExcelClose} size="sm">
                <Modal.Header>
                    <Modal.Title>Excel Import/Export</Modal.Title>
                    <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={handleExcelClose}>
                        <span aria-hidden="true">&times;</span>
                    </button>
                </Modal.Header>
                <Modal.Body className="position-relative">
                    <Select
                        options={rows?.map(row => ({ value: row.recordId, label: row.title }))}
                        placeholder={"Select Price List"}
                        onChange={(e) => setSelectedPriceList(e)}
                        value={selectedPriceList}
                    />
                    <hr />
                    <br />
                    <input
                        autoComplete="off"
                        className="ember-text-field ember-view form-control"
                        id="originalFileName"
                        type="file"
                        onChange={(e) => handleFileRead(e)}
                        size="small"
                        variant="standard"
                    />
                    <span style={{color: '#333', float: 'right', paddingTop: '4px'}}>* Please upload only .xlsx files.</span>
                </Modal.Body>

                <Modal.Footer style={{ zIndex: excelUploading ? 1000 : 100 }}>
                    <a
                        style={{ paddingRight: "15px", textDecoration: 'none' }}
                        href={selectedPriceList ? `${BASE_URL_INVENTORY}${DOWNLOAD_ITEM_PRICE_URL}${selectedPriceList.value}` : "#"}
                        target="_blank"
                        rel="noreferrer"
                        download
                        onClick={(e) => {
                            if (!selectedPriceList) {
                                e.preventDefault();
                                toast.error("Please select a price list");
                            }
                        }}
                    >
                        <Button variant="contained" color="primary" disabled={!selectedPriceList}>
                            <DownloadIcon />
                            Download
                        </Button>
                    </a>
                    <Button variant="contained" color="primary" onClick={handleExcelUpload} disabled={excelUploading || !selectedPriceList || !fileForExcel.fileBase64}>
                        {excelUploading ? (
                            <Spinner
                                className="costomLoader mr-2"
                                animation="border"
                                size="sm"
                            />
                        ) : (
                            <ImportExportIcon />
                        )}
                        Upload
                    </Button>
                </Modal.Footer>
            </Modal>
            <Toaster />

        </>
    );
};

export default PriceList;
